import { z } from 'zod';
import { emailSchema, nonEmptyTrimmed, optionalPhone, optionalTrimmed } from './primitives.js';

export const KNOWN_AGENCIES = [
  'Hays Education',
  'Reed Specialist Recruitment',
  'Adecco',
  'Randstad',
  'Manpower',
  'Protocol Education',
  'Teaching Personnel',
  'Tradewind Recruitment',
  'Prospero Teaching',
  'Supply Desk',
] as const;

export const agencySchema = z.object({
  name: nonEmptyTrimmed('Agency name', 160),
  branch: optionalTrimmed(120),
  consultantName: nonEmptyTrimmed('Consultant name', 120),
  consultantEmail: emailSchema,
  consultantMobile: optionalPhone,
});

export type Agency = z.infer<typeof agencySchema>;
